import { GetterTree, MutationTree, ActionTree, Module } from "vuex";
import { RootState } from "..";
import { Quantity } from "@/core/_models/quantity.model";
import Vue from "vue";

class QuantitiesState {
  items: Quantity[] | undefined = undefined;
}

export const state: QuantitiesState = {
  items: undefined
};

const namespaced: boolean | undefined = true;

const getters = {
  items(state) {
    if (!state.items) return [];

    return state.items.sort((a, b) => (a.Index < b.Index ? -1 : 1));
  },
  item:
    (state) =>
    (DatabaseId: string): Quantity | undefined => {
      if (!state.items) {
        return undefined;
      }

      const quantity = state.items.find((x) => x.DatabaseId == DatabaseId);

      return quantity;
    }
} as GetterTree<QuantitiesState, any>;

const mutations = {
  SET_QUANTITIES(state, quantities: Quantity[]) {
    state.items = quantities;
  },
  UPDATE_QUANTITY(state, quantity: Quantity) {
    if (!state.items) return;

    const existingItem = state.items.findIndex((x) => x.DatabaseId === quantity.DatabaseId);

    if (existingItem !== -1) {
      Vue.set(state.items, existingItem, quantity);
    } else {
      state.items.push(quantity);
    }
  },
  REMOVE_QUANTITY(state, DatabaseId: string) {
    if (state.items != undefined) {
      state.items = state.items?.filter((x) => x.DatabaseId != DatabaseId);
    }
  }
} as MutationTree<QuantitiesState>;

const actions = {
  pushQuantities({ commit, rootState }): any {
    const quantities = rootState.quantities.items;

    quantities.forEach((quantity: Quantity) => {
      commit("UPDATE_QUANTITY", quantity);
    });
  }
} as ActionTree<QuantitiesState, any>;

export const quantities: Module<QuantitiesState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
};
